import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Layout2 from './components/Layout/Layout2';
import Layout3 from './components/Layout/Layout3';
import Layout4 from './components/Layout/Layout4';
import Home from './components/Pages/Home';
import HomeStyle2 from './components/Pages/HomeStyle2';
import HomeStyle3 from './components/Pages/HomeStyle3';
import HomeStyle4 from './components/Pages/HomeStyle4';
import About from './components/Pages/About';
import Doctors from './components/Pages/Doctors';
import Blog from './components/Pages/Blog';
import Appointments from './components/Pages/Appointments';
import Departments from './components/Pages/Departments';
import DepartmentDetails from './components/Pages/DepartmentDetails';
import BlogDetails from './components/Pages/BlogDetails';
import DoctorDetails from './components/Pages/DoctorDetails';
import PricingPlan from './components/Pages/PricingPlan';
import ComparePlan from './components/Pages/ComparePlan';
import Gallery from './components/Pages/Gallery';
import Timetable from './components/Pages/Timetable';
import Contact from './components/Pages/Contact';
import { useEffect } from 'react';
import ErrorPage from './components/Pages/ErrorPage';
import Layout5 from './components/Layout/Layout5';
import HomeStyle5 from './components/Pages/HomeStyle5';
import HomeStyle6 from './components/Pages/HomeStyle6';
import Membershipplan from './components/Pages/Membershipplan';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import TermsCondition from './components/Pages/TermsCondition';
import PackageDetail from './components/Pages/PackageDetails';
import FloatingButton from './components/FloatingButton';
import Faq from './components/Pages/Faq';
import Services from './components/Pages/Services';
import Article from './components/Pages/Article';
import ArticleDetails from './components/Pages/ArticleDetails';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="faq" element={<Faq />} />
          <Route path="services" element={<Services />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:blogId" element={<BlogDetails />} />
          <Route path="article" element={<Article />} />
          <Route path="article/:articleId" element={<ArticleDetails />} />
          <Route path="/packages/:id" element={<PackageDetail />} />
          <Route path="membership" element={<Membershipplan />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="termscondition" element={<TermsCondition />} />
          <Route path="pricing-plan" element={<PricingPlan />} />
          <Route path="compare-health-packages" element={<ComparePlan />} />


          {/* <Route
            path="departments/:departmentId"
            element={<DepartmentDetails />}
          />
          <Route path="appointments" element={<Appointments />} />
          <Route path="departments" element={<Departments />} />
          <Route path="doctors" element={<Doctors />} />
          <Route path="doctors/:doctorId" element={<DoctorDetails />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="timetable" element={<Timetable />} />
          <Route path="contact" element={<Contact />} />
      
        <Route element={<Layout2 />}>
          <Route path="home-v2" element={<HomeStyle2 />} />
          <Route path="home-v6" element={<HomeStyle6 />} />
        </Route>
        <Route path="home-v3" element={<Layout3 />}>
          <Route index element={<HomeStyle3 />} />
        </Route>
        <Route path="home-v4" element={<Layout4 />}>
          <Route index element={<HomeStyle4 />} />
        </Route>
        <Route path="home-v5" element={<Layout5 />}>
          <Route index element={<HomeStyle5 />} />
        </Route> */}
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <FloatingButton />
    </>
  );
}

export default App;
